import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

export function Security() {
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);

  const handleChangePassword = () => {
    console.log('Change password');
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Security</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-base font-medium">Change Password</p>
          </div>
          <Button variant="outline" onClick={handleChangePassword}>
            Change
          </Button>
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <Label htmlFor="two-factor" className="text-base font-medium">
              Two-Factor Authentication
            </Label>
            <p className="text-muted-foreground text-sm">Enable 2FA for enhanced security.</p>
          </div>
          <Switch id="two-factor" checked={twoFactorEnabled} onCheckedChange={setTwoFactorEnabled} />
        </div>
      </CardContent>
    </Card>
  );
}
